import React from 'react';
import { Box, Button, ColumnLayout, Container, SpaceBetween } from '@amzn/awsui-components-react/polaris';
import CONSTANTS from 'src/utils/constants';
import { ColumnSourceType } from 'src/models/segment-cdt/SegmentCdtTypes';

/**
 * Column-type chooser: the two source types CR2 supports, each with an icon and a description that
 * makes sense for that type. DERIVED_PCT / DERIVED_BAL are out of scope and not offered.
 */
const TYPES = [
    {
        sourceType: ColumnSourceType.PULL_GL,
        icon: 'segment-gl-pull.svg',
        title: 'GL Balance Pull',
        description: 'Pull balances from the General Ledger for each value of the segment.',
    },
    {
        sourceType: ColumnSourceType.MANUAL,
        icon: 'segment-manual-upload.svg',
        title: 'Manual Upload',
        description: 'Add a blank column and fill its values later with Upload.',
    },
];

export default function ColumnTypeChooser(props: {
    onPick: (sourceType: ColumnSourceType) => void;
    onCancel: () => void;
}) {
    const { onPick, onCancel } = props;
    return (
        <SpaceBetween size="l">
            <Box variant="h4">Choose the column type</Box>
            <ColumnLayout columns={2}>
                {TYPES.map((t) => (
                    <Container key={t.sourceType}>
                        {/* Fixed-height flex column keeps both cards the same size and pins Select to the
                            bottom, so a longer description on one card cannot misalign the buttons. */}
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                textAlign: 'center',
                                gap: '8px',
                                minHeight: '190px',
                            }}
                        >
                            <img src={CONSTANTS.IMAGE_PATH + t.icon} width={44} height={44} alt="" />
                            <Box variant="strong">{t.title}</Box>
                            <Box variant="small" color="text-body-secondary">{t.description}</Box>
                            <div style={{ marginTop: 'auto' }}>
                                <Button onClick={() => onPick(t.sourceType)}>Select</Button>
                            </div>
                        </div>
                    </Container>
                ))}
            </ColumnLayout>
            <Box float="right">
                <Button onClick={onCancel}>Back to columns</Button>
            </Box>
        </SpaceBetween>
    );
}
